export default {
  // root: (process.env.NODE_ENV !== 'production' || window.location.href.indexOf('elantra.developer.eub-inc.com') > 0) ? '//elantra.developer.eub-inc.com' : '//elantran.vintro.cn',
  root: (process.env.NODE_ENV !== 'production' || window.location.href.indexOf('elantran-test.developer.eub-inc.com') > 0) ? '//elantran-test.developer.eub-inc.com' : '//elantran.vintro.cn',
  token_key: 'asian_games_token',
  current_key: 'asian_games_token_current'
}
